import { jsxs, jsx } from 'react/jsx-runtime';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';

const DefaultRepoBranchPicker = ({
  onChange,
  state,
  rawErrors,
  isDisabled,
  required
}) => {
  const { branch } = state;
  return /* @__PURE__ */ jsxs(
    FormControl,
    {
      margin: "normal",
      required,
      error: rawErrors?.length > 0 && !branch,
      children: [
        /* @__PURE__ */ jsx(
          TextField,
          {
            id: "branchInput",
            label: "Branch",
            disabled: isDisabled,
            onChange: (e) => onChange({ branch: e.target.value }),
            value: branch
          }
        ),
        /* @__PURE__ */ jsx(FormHelperText, { children: "The branch of the repository" })
      ]
    }
  );
};

export { DefaultRepoBranchPicker };
//# sourceMappingURL=DefaultRepoBranchPicker.esm.js.map
